import { render, staticRenderFns } from "./TariffCalculatorProducts.vue?vue&type=template&id=fc22d340&"
import script from "./TariffCalculatorProducts.vue?vue&type=script&lang=ts&"
export * from "./TariffCalculatorProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports